import {
  CLEAR_INDIVIDUAL_CUSTOMER,
  CLEAR_INDIVIDUAL_CUSTOMER_TRANSACTIONS_ALL,
  GET_CUSTOMER_SUCCESS,
  GET_INDIVIDUAL_CUSTOMER,
  GET_INDIVIDUAL_CUSTOMER_ALL,
  GET_INDIVIDUAL_CUSTOMER_LAST5_TRANSACTION,
} from "../actions/customer";

const initialState = {
  customerData: [],
  individualCustomer: {},
  last5Transactions: [],
  allTransactions: [],
  withdrawlRequestData: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_SUCCESS:
      return { ...state, customerData: action.payload };
    case GET_INDIVIDUAL_CUSTOMER:
      return { ...state, individualCustomer: action.payload };
    case GET_INDIVIDUAL_CUSTOMER_LAST5_TRANSACTION:
      return { ...state, last5Transactions: action.payload };
    case GET_INDIVIDUAL_CUSTOMER_ALL:
      return { ...state, allTransactions: action.payload };
    case CLEAR_INDIVIDUAL_CUSTOMER:
      return { ...state, individualCustomer: {}, last5Transactions: [] };

    case CLEAR_INDIVIDUAL_CUSTOMER_TRANSACTIONS_ALL:
      return { ...state, allTransactions: [] };

    default:
      return state;
  }
};
